/* import __COLOCATED_TEMPLATE__ from './power.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type PowerResults from '../../models/results/sub-results/power';

interface PowerFigureArgs {
  model: PowerResults;
  showHelp?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;
}

export default class PowerFigure extends Component<PowerFigureArgs> {
  @action showPowerHelp(): void {
    const title = 'help.common.power.title';
    const message = 'help.common.power.message';
    if (this.args.showHelp) {
      this.args.showHelp(title, message);
    }
  }
}
